import { Observable, OperatorFunction, pipe, UnaryFunction } from "rxjs";
import { filter } from "rxjs/operators";

/**
 * this operator infers that output value is truthy
 */
export function filterFalsy<T>(): UnaryFunction<Observable<T | null | undefined>, Observable<T>> {
    return pipe(filter((value) => !!value) as OperatorFunction<T | null | undefined, T>);
}

/**
 * this operator filters out array that has falsy values and infers that ALL array values are truthy
 */
export function filterFalsyArray<T extends readonly unknown[]>(): UnaryFunction<
    Observable<T>,
    Observable<{ [K in keyof T]: NonNullable<T[K]> }>
> {
    return pipe(filter((array): array is { [K in keyof T]: NonNullable<T[K]> } => array.every((value) => !!value))) as UnaryFunction<
        Observable<T>,
        Observable<{ [K in keyof T]: NonNullable<T[K]> }>
    >;
}
